module.exports = __webpack_public_path__ + "img/no-data.76635eb6.svg";